import APIService from '../../../../Services/APIService';
import { Apis } from '../../../../Services/app.constants';

const encode = (value) => encodeURIComponent(value ?? '');

const normalizeEmptyHelpFilesResponse = (response) => {
  const payload = response?.data ?? response;
  const generalError = payload?.general_error ?? payload?.data?.general_error;
  if (generalError === 'No files found') {
    return { status: 200, data: [] };
  }

  if (Array.isArray(payload)) {
    return { status: 200, data: payload };
  }

  return response;
};

export const templateAssetService = {
  listQuickTemplates({
    page = 0,
    search = '',
    sortField = 'created_at',
    sortOrder = 'desc',
    category = '',
    botNumber = '',
    limit = 10,
    organisationId = '',
    status = 'APPROVED',
  } = {}) {
    return APIService.get(
      `${Apis.getWhatsappTemplate}?next_page=${Number(page) + 1}` +
        `&search=${encode(search)}&sort_field=${encode(sortField)}` +
        `&sort_order=${encode(sortOrder)}&category=${encode(category)}` +
        `&bot_number=${encode(botNumber)}&limit=${encode(limit)}` +
        `&company_id=${encode(organisationId)}&status=${encode(status)}`
    );
  },

  resolveQuickTemplate(templateName, botNumber = '') {
    if (!templateName) throw new Error('Template name is required');
    return APIService.get(
      `${Apis.whatsappTemplate}?bot_number=${encode(botNumber)}&name=${encode(templateName)}`
    );
  },

  async listHelpFiles(leadsFormId) {
    if (!leadsFormId) throw new Error('Lead form ID is required');

    try {
      const response = await APIService.get(
        `/v0/ui/leads/helpfile/files/?leads_form_id=${encode(leadsFormId)}`
      );

      return normalizeEmptyHelpFilesResponse(response);
    } catch {
      return { status: 200, data: [] };
    }
  },

  uploadHelpFile(leadsFormId, file, fileName = 'help file') {
    if (!leadsFormId) throw new Error('Lead form ID is required');
    if (!file) throw new Error('Help file is required');
    const formData = new FormData();
    formData.append('leads_form_id', String(leadsFormId));
    formData.append('file_name', fileName);
    formData.append('excel_file', file);
    return APIService.post('/v0/ui/leads/helpfile/upload/', formData, {
      'Content-Type': 'multipart/form-data',
    });
  },

  getHelpFileDetails(fileId, { search = '', columnFilters = {} } = {}) {
    if (!fileId) throw new Error('File ID is required');
    const filters = Object.entries(columnFilters)
      .filter(([, value]) => Boolean(value))
      .map(([key, value]) => `&${encodeURIComponent(key)}=${encode(value)}`)
      .join('');
    return APIService.get(
      `/v0/ui/leads/helpfile/file-detail/?file_id=${encode(fileId)}&search=${encode(
        search
      )}${filters}`
    );
  },

  deleteHelpFile(fileId) {
    if (!fileId) throw new Error('File ID is required');
    return APIService.remove(
      `/v0/ui/leads/helpfile/file-detail/?file_id=${encode(fileId)}`
    );
  },
};

export default templateAssetService;
